import { SearchHeader } from "../components/search-header";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_SearchHeader";

const create = (data): JSX.Element => {
  return <SearchHeader {...data} />;
};

export default { test, create };
